import React, { useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import { columnDefs, defaultColDef } from './_utils/definitions-config.jsx';
import { getFilters, getJobs } from '../../services/apiService';
import { toast } from 'react-toastify';
import UpdateJobModal from './_components/updateJobModal.jsx';
const pageSize = 10;

const JobBoard = () => {
  const [currentSelected, setCurrentSelected] = React.useState(null);
  const [filtersOptions, setFiltersOptions] = React.useState(null);
  const [gridApi, setGridApi] = React.useState(null);

  const [isOpen, setIsOpen] = React.useState(false);

  const getFilter = async () => {
    try {
      const res = await getFilters();
      if (res) {
        setFiltersOptions(res);
      }
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    getFilter();
  }, []);

  const getServerSideDatasource = () => {
    return {
      getRows: (params) => {
        const body = {
          pagination: {
            start: params.request.startRow,
            end: params.request.endRow,
          },
        };

        try {
          // call the api here to fetch and set data to the column.
          getJobs(body).then((response) => {
            params.successCallback(
              response?.data || [],
              response?.totalCount || 0
            );
          });
        } catch (error) {
          console.error(error);
          params.failCallback();
          toast.error('Failed to fetch data');
        }
      },
    };
  };

  const onGridReady = React.useCallback((params) => {
    console.log(params, 'params');
    setGridApi(params);
    const datasource = getServerSideDatasource();
    params?.api?.setServerSideDatasource(datasource);
  }, []);

  const onFilterChanged = async (props) => {
    onGridReady();
  };
  const agGridColumnDefs = useMemo(() => {
    return columnDefs(setCurrentSelected, setIsOpen);
  }, [setCurrentSelected, setIsOpen]);
  console.log(agGridColumnDefs, 'agGridColumnDefs');

  return (
    <div>
      <div className='bg-white py-8 px-6'>
        <div className='flex items-center gap-2 '>
          <div className='text-2xl font-semibold'>Job Board</div>
        </div>
      </div>
      <div
        className='ag-theme-alpine z-50'
        style={{ height: '85vh', width: '100%' }}
      >
        <AgGridReact
          columnDefs={agGridColumnDefs}
          onFilterChanged={onFilterChanged}
                    defaultColDef={defaultColDef}
          tooltipShowDelay={0}
          tooltipHideDelay={2000}
          onGridReady={onGridReady}
          rowHeight={60}
          domLayout='autoHeight'
          rowModelType='serverSide'
          serverSideStoreType='partial'
          animateRows={true}
          serverSideInfiniteScroll={true}
          pagination={true}
          suppressPaginationPanel={false}
          paginationPageSize={pageSize}
          cacheBlockSize={pageSize}
        />
      </div>

      <UpdateJobModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        currentSelected={currentSelected}
        filtersOptions={filtersOptions}
        onGridReady={onGridReady}
        gridApi={gridApi}
      />
    </div>
  );
};

export default JobBoard;
